import React, { Component } from 'react';
import Select from 'react-select';
import Button from './components/Button';
import Map from './components/Map';
import data from './data';
import './App.css';

//
let key;
const options = data.map((item) => {
  key = Object.keys(item)[0];
  return { value: key, label: item[key].nombre };
});


class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedCity: null,
      activePopulation: true,
      isMobile: window.innerWidth < 768,
      url: ''
    };

    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.getImageUrl = this.getImageUrl.bind(this);
  }

  componentDidMount() {
    const selectedCity = options.find((item) => { return item.value === 'valencia' });
    const url = this.getImageUrl(true, selectedCity);
    
    this.setState({ selectedCity, url });
  }

  handleSelectChange(selectedCity) {
    const url = this.getImageUrl(this.state.activePopulation, selectedCity);

    this.setState({ selectedCity, url });
  }

  handleClick(activePopulation) {
    const url = this.getImageUrl(activePopulation, this.state.selectedCity);

    this.setState({ activePopulation, url });
  }

  getImageUrl(activePopulation, cityObj) {
    const type = activePopulation ? 'pobla' : 'renta';
    const city = data.find((item) => { return Object.keys(item)[0] === cityObj.value });
    const resolution = this.state.isMobile ? 'mobile' : 'desktop';
    const imageUrl = city[Object.keys(city)[0]][type][resolution];

    return imageUrl;
  }


  render() {
    const { selectedCity, activePopulation, url } = this.state;

    return (
      <div className="App">
        <p className="App-select__title">Selecciona una ciudad</p>
        <Select
          className="custom-select"
          value={selectedCity}
          onChange={this.handleSelectChange}
          options={options}
          placeholder="Selecciona una ciudad"
          noOptionsMessage={() => ('Sin resultados')}
          theme={(theme) => ({
            ...theme,
            borderRadius: 0,
            colors: {
              ...theme.colors,
              primary: '#cccccc',
              primary25: '#efefef'
            }
          })}
        />
        <div className="App-buttons">
          <Button 
            text="Población inmigrante (%)"
            cb={() => this.handleClick(true)}
            active={activePopulation}
          />
          <Button 
            text="Renta media (€)"
            cb={() => this.handleClick(false)}
            active={!activePopulation}
          />
        </div>
        <div className="App-map"> 
          <Map url={url} population={activePopulation} />
        </div>
      </div>
    );
  }
}

export default App;
